const common = {
  Loading: "로딩 중",
  signUp: "로그인",
  login: "로그 인",
  logout: "로그아웃",
  email: "이메일",
  emailFormatErrorTips: "이메일 형식이 잘못되었습니다.",
  emailDifferentTips: "두 번 입력한 메일함이 일치하지 않습니다.",
  emailRegisteredTips: "등록된 이메일입니다. 다른 이메일을 선택하세요.",
  password: "비밀번호",
  passwordFormatErrorTips: "비밀번호는 8-50자여야 하며 숫자, 문자 또는 특수 문자 중 두 개 이상 포함해야 합니다.",
  passwordDifferentTips: "두 번에 동일한 비밀번호를 입력해주세요",
  verificationCode: "검증코드",
  verificationCodeErrorTips: "확인코드가 잘못되었습니다.",
  confirm: "확인하기",
  cancel: "취소하기",
  submit: "제출하기",
  confirmEmail: "이메일 확인하기",
  formEmptyErrorTips: "여기는 비어 있을 수 없습니다.",
  country: "국가/지역",
  birthday: "생일",
  anonymous: "익명",
  name: "이름",
  nameFormatErrorTips: "사용자 이름은 50자 이내여야 하며 특수 문자를 포함할 수 없습니다.",
  okBtn: "네.",
  serverErrorTips: "죄송합니다. 문제가 발생했습니다. 다시 시도하십시오.",
  updateSuccessTips: "성공적으로 수정되었습니다.",
  authorizationExpiredErrorTips: "인증이 만료되었습니다. 다시 로그인하십시오.",
  requestFrequentlyErrorTips: "짧은 시간 동안 동일한 요청이 많았습니다. 잠시후 다시 시도하십시오.",
  GetCode:'코드 받기'
};

export default common;
